import { render, staticRenderFns } from "./cutImgUp.vue?vue&type=template&id=8a061340&scoped=true"
import script from "./cutImgUp.vue?vue&type=script&lang=js"
export * from "./cutImgUp.vue?vue&type=script&lang=js"
import style0 from "./cutImgUp.vue?vue&type=style&index=0&id=8a061340&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a061340",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/web_acadmin_online_docker/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8a061340')) {
      api.createRecord('8a061340', component.options)
    } else {
      api.reload('8a061340', component.options)
    }
    module.hot.accept("./cutImgUp.vue?vue&type=template&id=8a061340&scoped=true", function () {
      api.rerender('8a061340', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/cutImgUp.vue"
export default component.exports